// src/components/Exaustores/ExaustorCard/ExaustorCard.jsx
import React from "react";
import Ventilador from "../../../assets/svg/ventilador";
import Cronometro from "../../../assets/svg/cronometro";
import ExaustorMessage from "../ExaustorMessage/ExaustorMessage";
import UnidadesList from "../UnidadeList/UnidadeList";
import {
  formatTime,
  getDisplayTimer,
  getExaustorButtonText,
  getExaustorButtonClass,
  getMessageType,
  shouldShowUnidades,
} from "../../../utils/utilsExaustor";

/**
 * Card completo de um exaustor
 * @param {Object} exaustor - Dados completos do exaustor
 * @param {Function} onToggleExaustor - Callback para ligar/desligar exaustor
 * @param {Function} onToggleUnidade - Callback para ligar/desligar unidade
 */
const ExaustorCard = ({ exaustor, onToggleExaustor, onToggleUnidade }) => {
  // Determina qual mensagem (se houver) deve ser exibida
  const messageInfo = getMessageType(exaustor);
  
  // Verifica se deve mostrar lista de unidades
  const showUnidades = shouldShowUnidades(exaustor);

  // Timer a ser exibido
  const displayTimer = getDisplayTimer(exaustor);

  // ✅ Ventilador fica ligado APENAS se status for "on"
  const ventiladorLigado = exaustor.status === "on";

  return (
    <div className="exaustor">
      <h2 className="titleExaustor">{exaustor.id}</h2>

      <div className="campoDasUnidades">
        {/* Mensagem especial (manual, dependente, etc) */}
        {messageInfo && (
          <ExaustorMessage type={messageInfo.type} data={messageInfo.data} />
        )}

        {/* Lista de unidades (se aplicável) */}
        {showUnidades && (
          <UnidadesList
            unidades={exaustor.unidades}
            exaustorId={exaustor.id}
            onToggleUnidade={onToggleUnidade}
          />
        )}
        
        {/* Se não tem mensagem nem unidades */}
        {!messageInfo && !showUnidades && (
          <p id="nenhumaUndText">Nenhuma unidade vinculada</p>
        )}
      </div>

      {/* Área do ventilador e controles */}
      <div className="exaustorCampo">
        <Ventilador
          className={
            ventiladorLigado ? "ventilador-ligado" : "ventilador-desligado"
          }
          width={"30%"}
          height={"85%"}
        />

        <div className="exaustorTimerCampo">
          <p className="timerText">
            <Cronometro className={"cronometroExaustor"} />
            {formatTime(displayTimer)}
          </p>

          <button
            id="buttonExaustor"
            className={`buttonExaustor ${getExaustorButtonClass(exaustor)}`}
            onClick={() => onToggleExaustor(exaustor.id)}
            disabled={exaustor.bloqueioApp === true}
          >
            {getExaustorButtonText(exaustor)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExaustorCard;